var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"label":_vm.label,"autocomplete":"off","items":_vm.items,"data-lpignore":"true","value":_vm.value,"clearable":_vm.clearable},on:{"input":function($event){return _vm.$emit('input',$event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }